<mat-chip-set class="pt-4" aria-label="Filters and search interactivity">
  @if (searchChip()) {
    <mat-chip
      [removable]="true"
      (removed)="triggerSearch.emit(null)"
      class="border-blue-500 bg-blue-50 text-blue-700 items-center gap-1 border pr-1 pl-2"
    >
      <mat-chip-avatar class="mb-1">
        <mat-icon>search</mat-icon>
      </mat-chip-avatar>
      {{ searchChip() }}

      <button [attr.aria-label]="'Remove search'" matChipRemove>
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip>
  }
  @for (filter of mappedFilters(); track $index) {
    @for (entry of filter.entries; track $index) {
      @if (entry.raw) {
        <mat-chip [removable]="true" (removed)="doRemoveFilter(filter.key, entry.raw)">
          {{ filter.label | titlecase }}: {{ entry.display }}
          <button [attr.aria-label]="'Remove filter:' + entry.display" matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip>
      }
    }
  }
</mat-chip-set>
